import { render, staticRenderFns } from "./ProfileDrawerMenu.vue?vue&type=template&id=43f873be&scoped=true&"
import script from "./ProfileDrawerMenu.vue?vue&type=script&lang=js&"
export * from "./ProfileDrawerMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDrawerMenu.vue?vue&type=style&index=0&id=43f873be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f873be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VList,VListItem,VListItemGroup,VSubheader})
